<template>
  <div class="bg-card rounded-[16px] border border-border p-4 sm:p-6">
    <div class="grid grid-cols-1 lg:grid-cols-[2.4fr_1fr] gap-6">
      <FeedCard
        :user-avatar="userAvatar"
        :user-name="userName"
        :watermark="true"
      />
      <AboutCard
        :user-avatar="userAvatar"
        :user-name="userName"
        :date-joined="dateJoined"
        :people-to-follow="peopleToFollow"
        :watermark="true"
      />
    </div>
  </div>
</template>

<script>
import FeedCard from "./FeedCard.vue";
import AboutCard from "./AboutCard.vue";

export default {
  name: "FeedAboutSection",
  components: {
    FeedCard,
    AboutCard,
  },
  props: {
    userAvatar: { type: String, required: true },
    userName: { type: String, required: true },
    dateJoined: { type: String, default: "" },
    peopleToFollow: { type: Array, default: () => [] },
  },
};
</script>
